/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useMemo, useEffect } from "react";
import { useScope, scopedList } from "../components/Scope";
import Publisher from "../core/publisher";
import { getId } from "../utils/getId";
const publishers = new Map();
export const useShard = (shard) => {
    var _a, _b;
    const { scopeId } = useScope();
    const id = useMemo(() => getId(scopedList, shard, scopeId), [scopeId]);
    const [state, setState] = useState((_b = (_a = publishers === null || publishers === void 0 ? void 0 : publishers.get(id)) === null || _a === void 0 ? void 0 : _a.getRecentlyData()) !== null && _b !== void 0 ? _b : shard.getInitialValue());
    const publisher = new Publisher();
    useEffect(() => {
        var _a, _b, _c;
        if (!id)
            return;
        if (!publishers.has(id)) {
            publishers.set(id, publisher);
        }
        if ((_a = publishers.get(id)) === null || _a === void 0 ? void 0 : _a.getRecentlyData()) {
            setState((_b = publishers.get(id)) === null || _b === void 0 ? void 0 : _b.getRecentlyData());
        }
        const subscribe = (_c = publishers.get(id)) === null || _c === void 0 ? void 0 : _c.subscribe((v) => {
            setState(v);
        });
        return () => subscribe === null || subscribe === void 0 ? void 0 : subscribe.unsubscribe();
    }, []);
    return [
        state,
        (v) => {
            var _a, _b;
            if (typeof v === "function") {
                const newValue = v(state);
                (_a = publishers.get(id)) === null || _a === void 0 ? void 0 : _a.publish(newValue);
                return;
            }
            (_b = publishers.get(id)) === null || _b === void 0 ? void 0 : _b.publish(v);
        },
    ];
};
//# sourceMappingURL=useShard.js.map